import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Director } from "../../common/contexts/TagsContext";

interface DirectorCardProps {
  director: Director;
  onDelete: () => void;
  onUpdate: (name: string) => void;
}

export const DirectorCard: React.FC<DirectorCardProps> = ({ director, onDelete, onUpdate }) => {
  const { t } = useTranslation();

  const [edits, setEdits] = useState<{ name?: string }>({});

  const nameVal = edits.name !== undefined ? edits.name : director.name;

  const handleChange = (value: string) => {
    setEdits({ name: value });
  };

  const handleBlur = () => {
    if (!edits.name) return;

    const newName = edits.name !== undefined ? edits.name : director.name;

    if (newName.trim()) {
      onUpdate(newName);
    }

    setEdits({});
  };

  return (
    <div
      data-testid={`director-card-${director.id}`}
      style={{
        background: "var(--color-panel-bg)",
        borderRadius: "var(--border-radius-md)",
        border: "2px solid var(--color-role-executive)",
        padding: "10px",
        boxShadow: "var(--shadow-card)",
      }}
    >
      <div
        data-testid={`director-header-${director.id}`}
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "5px",
          alignItems: "center",
        }}
      >
        <span style={{ fontSize: "1.2rem", marginRight: "8px" }}>
          <i className="bx bx-movie-play"></i>
        </span>
        <input
          data-testid={`director-name-input-${director.id}`}
          value={nameVal}
          onChange={(e) => handleChange(e.target.value)}
          onBlur={handleBlur}
          onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
          style={{
            background: "transparent",
            border: "none",
            color: "var(--color-text-primary)",
            fontWeight: "bold",
            fontSize: "0.9rem",
            width: "100%",
          }}
        />
        <button
          data-testid={`director-delete-${director.id}`}
          onClick={onDelete}
          style={{
            background: "transparent",
            border: "none",
            color: "var(--color-text-muted)",
            cursor: "pointer",
            fontSize: "1rem",
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
};
